export default __webpack_public_path__ + "static/media/qrCodeScan.4b491a82.png";